import React from 'react';
import { SellerProductBasicDetails } from './types';
import { useTranslation } from 'react-i18next';
import TitleText from '../../atoms/TitleText';
import InfoText from '../../atoms/InfoText';
import { useDispatch } from 'react-redux';
import { setModalId } from '../../../store/slices/publicSlice';

type Props = {
  basicDetails?: SellerProductBasicDetails;
};

export default function ProductCertificationsSection({ basicDetails }: Props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  if (
    !basicDetails?.certificateDocs ||
    basicDetails.certificateDocs.length === 0
  ) {
    return null;
  }

  const handlePreview = (url?: string) => {
    if (!url) return;
    const isImage = url.match(/\.(jpeg|jpg|gif|png|webp|svg)$/i);
    const isVideo = url.match(/\.(mp4|webm|ogg)$/i);

    if (isImage || isVideo) {
      dispatch(
        setModalId({
          id: 'VIEW_FILE',
          extraData: { url, type: isImage ? 'IMAGE' : 'VIDEO' },
        })
      );
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <div
      className="flex flex-col gap-4 w-full"
      data-testid="seller-product-certifications-section"
    >
      <TitleText
        text={t('components.productDetailsPage.certifications')}
        size="lg"
        className="!font-bold !text-[#090909] dark:!text-white"
      />

      <div className="flex flex-col" data-testid="seller-product-certs-list">
        {basicDetails.certificateDocs.map((cert) => (
          <div
            key={cert.id}
            className="flex justify-between items-center px-3 py-4 text-sm even:bg-gray-50 dark:even:bg-gray-800/50"
            data-testid={`cert-doc-${cert.id}`}
          >
            <InfoText
              text={cert.name}
              className="!text-[#090909] dark:!text-gray-400 !text-sm !m-0"
            />
            <div
              onClick={() => handlePreview(cert.url)}
              className="cursor-pointer hover:underline"
            >
              <InfoText
                text={
                  cert.url ? cert.url.split('/').pop() || cert.name : cert.name
                }
                className="!font-bold !text-[#090909] dark:!text-white !text-sm !text-right !m-0"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
